(() => {
  if (!document.querySelector('[data-clean-single-variant-sibling-url]')) return;

  const url = new URL(window.location.href);
  if (!url.searchParams.has('variant')) return;

  url.searchParams.delete('variant');
  const search = url.searchParams.toString();
  const nextUrl = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
  window.history.replaceState(window.history.state, '', nextUrl);
})();

(() => {
  const container = document.querySelector('[data-preserve-mobile-sibling-scroll]');
  if (!container || container.dataset.mobileSiblingScrollBound === 'true') return;
  container.dataset.mobileSiblingScrollBound = 'true';

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const storageKey = 'transportMobileSiblingScroll';
  const maxRestoreAge = 15_000;

  let pendingRestore = null;
  try {
    const storedRestore = window.sessionStorage.getItem(storageKey);
    if (storedRestore) {
      pendingRestore = JSON.parse(storedRestore);
      window.sessionStorage.removeItem(storageKey);
    }
  } catch (error) {
    pendingRestore = null;
  }

  if (
    mobileQuery.matches &&
    pendingRestore &&
    pendingRestore.pathname === window.location.pathname &&
    Number.isFinite(pendingRestore.viewportTop) &&
    Date.now() - pendingRestore.createdAt <= maxRestoreAge
  ) {
    let cancelFurtherRestores = false;
    const cancelRestore = () => {
      cancelFurtherRestores = true;
    };
    const restorePosition = () => {
      if (cancelFurtherRestores) return;
      const offset = container.getBoundingClientRect().top - pendingRestore.viewportTop;
      if (Math.abs(offset) >= 1) window.scrollBy(0, offset);
    };

    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, cancelRestore, { once: true, passive: true });
    });
    window.requestAnimationFrame(() => window.requestAnimationFrame(restorePosition));
    if (document.readyState === 'complete') {
      window.setTimeout(restorePosition, 0);
    } else {
      window.addEventListener('load', restorePosition, { once: true });
    }
    window.setTimeout(restorePosition, 600);
  }

  container.addEventListener('click', (event) => {
    const link = event.target.closest('.product-form__input--siblings a[href]');
    if (
      !link ||
      !container.contains(link) ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.hasAttribute('download') ||
      (link.target && link.target !== '_self')
    ) {
      return;
    }

    const targetUrl = new URL(link.href, window.location.href);
    if (targetUrl.origin !== window.location.origin) return;

    if (mobileQuery.matches) {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          pathname: targetUrl.pathname,
          viewportTop: container.getBoundingClientRect().top,
          createdAt: Date.now()
        }));
      } catch (error) {
        // Replacement navigation remains available when session storage is unavailable.
      }
    }

    event.preventDefault();
    window.location.replace(targetUrl.href);
  });
})();

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.hasColorwaySiblings = this.dataset.hasColorwaySiblings === 'true';
      this.priceRequestController = null;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.cleanInitialProductURL();
      if (this.applyColorFromURL()) {
        return;
      }
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.updateOptions();
      this.updateMasterId();
      const didSelectInitialMediaVariant = this.selectFirstAvailableVariantForInitialMediaOption();
      if (!didSelectInitialMediaVariant) {
        this.selectFirstAvailableOptions();
      }
      this.updateVariantText();
      this.filterImgVariant();
      if (!this.currentVariant) {
        this.clearVariantInput();
        this.updatePickupAvailability();
        this.toggleAddButton(true, this.getUnavailableButtonText(true));
        this.renderSelectedColorPrice();
      } else {
        this.updateMedia();
        this.updateVariantInput();
        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        this.renderProductInfo();
      }

      this.setImageSet();
      this.refreshVariantMedia();
    }

    cleanInitialProductURL() {
      if (this.sticky || this.dataset.updateUrl === 'false') return;
      const url = new URL(window.location.href);
      const originalUrl = `${url.pathname}${url.search}${url.hash}`;
      ['_pos', '_fid', '_ss'].forEach((parameter) => url.searchParams.delete(parameter));
      if (this.hasColorwaySiblings) {
        url.searchParams.delete('variant');
      }
      const search = url.searchParams.toString();
      const nextUrl = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
      if (nextUrl !== originalUrl) {
        window.history.replaceState({}, '', nextUrl);
      }
    }

    refreshVariantMedia() {
      const refresh = () => {
        this.filterImgVariant();
        this.updateMedia();
      };

      window.requestAnimationFrame(refresh);
      window.setTimeout(refresh, 250);
      window.setTimeout(refresh, 1000);
    }

    selectFirstAvailableOptions() {
      let changed = false;
      this.fieldsets.forEach((fieldset) => {
        // Handle <select>
        const select = fieldset.querySelector('select');
        if (select) {
          const selectedOption = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
          const preserveBlankMultiOption = selectedOption && !selectedOption.value && this.fieldsets.length > 1;
          if (selectedOption && selectedOption.disabled && !preserveBlankMultiOption) {
            for (let i = 0; i < select.options.length; i++) {
              if (!select.options[i].disabled) {
                select.selectedIndex = i;
                changed = true;
                break;
              }
            }
          }
        }
        const checkedInput = fieldset.querySelector('input:checked');
        if (checkedInput && (checkedInput.disabled || checkedInput.classList.contains('is-disabled'))) {
          const availableInput = Array.from(fieldset.querySelectorAll('input')).find((input) => {
            return !input.disabled && !input.classList.contains('is-disabled');
          });
          if (availableInput) {
            checkedInput.checked = false;
            availableInput.checked = true;
            changed = true;
          }
        }
      });
      if (changed) {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantText();
      }
      return changed;
    }

    onVariantChange(event) {
      const changedFieldset = event?.target?.closest('fieldset');
      const shouldResetGallery = this.isMediaOptionFieldset(changedFieldset);
      const mobileScrollAnchor = window.matchMedia('(max-width: 767px)').matches
        ? changedFieldset
        : null;
      const mobileScrollAnchorTop = mobileScrollAnchor?.getBoundingClientRect().top;
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      this.updateOptions();
      this.updateMasterId();
      const didSelectFirstVariant = this.selectFirstAvailableVariantForChangedOption(changedFieldset);
      if (!didSelectFirstVariant) {
        this.selectFirstAvailableOptions();
      }
      this.filterImgVariant();
      if (this.updateUrl) {
        this.updateURL();
      }

      if (!this.currentVariant) {
        this.clearVariantInput();
        this.updatePickupAvailability();
        this.toggleAddButton(true, window.theme.variantStrings.selectOptions, true);
        this.setUnavailable();
        this.renderSelectedColorPrice();
      } else {
        this.priceRequestController?.abort();
        this.updateMedia({ scrollPage: shouldResetGallery });
        this.updateVariantInput();
        this.updatePickupAvailability();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
      if (mobileScrollAnchor && Number.isFinite(mobileScrollAnchorTop)) {
        window.requestAnimationFrame(() => {
          const scrollDelta = mobileScrollAnchor.getBoundingClientRect().top - mobileScrollAnchorTop;
          if (Math.abs(scrollDelta) > 1) {
            window.scrollBy({ top: scrollDelta, behavior: 'auto' });
          }
        });
      }

      // custom function to add "sold out" to disabled select options
      //markSoldOutOptions();
    }

    filterImgVariant() {
      if (!this.productSlider) {
        return;
      }

      const optionValueSet = this.getAllVariantOptionValueSet();
      const mediaFilterOptionIndex = this.getMediaFilterOptionIndex();
      const selectedMediaValue = mediaFilterOptionIndex
        ? this.normalizeImageFilterValue((this.options || [])[mediaFilterOptionIndex - 1])
        : '';
      const mediaOptionValues = mediaFilterOptionIndex
        ? this.getVariantOptionValueSet(mediaFilterOptionIndex)
        : new Set();
      const firstImageSlide = this.productSlider.querySelector('.product-images__slide--image');

      this.productSlider.querySelectorAll('[id^="Slide-"]').forEach((slide) => {
        const isImageSlide = slide.classList.contains('product-images__slide--image');
        if (!isImageSlide || !optionValueSet.size || !mediaFilterOptionIndex) {
          slide.style.display = '';
          return;
        }

        const mediaFilterTokens = this.getMediaFilterTokens(slide.dataset.alt)
          .filter((token) => optionValueSet.has(token));
        let mediaValuesForOption = mediaFilterTokens
          .filter((token) => mediaOptionValues.has(token));
        if (!mediaValuesForOption.length) {
          mediaValuesForOption = this.getMediaFilterValuesFromSource(
            slide.dataset.mediaSrc,
            mediaFilterOptionIndex
          );
        }

        if (!mediaValuesForOption.length) {
          slide.style.display = '';
          return;
        }

        if (!selectedMediaValue) {
          slide.style.display = slide === firstImageSlide ? '' : 'none';
          return;
        }

        slide.style.display = mediaValuesForOption.includes(selectedMediaValue) ? '' : 'none';
      });

      this.updateVisibleMediaHero(mediaFilterOptionIndex, selectedMediaValue);

      const productSliderElement = this.productSlider.matches('product-slider')
        ? this.productSlider
        : this.productSlider.querySelector('product-slider');
      if (typeof productSliderElement?.handleVariantImagesUpdated === 'function') {
        productSliderElement.handleVariantImagesUpdated(this.currentVariant);
      }

      const event = new CustomEvent('variantImagesUpdated', {
        bubbles: true,
        detail: { currentVariant: this.currentVariant }
      });
      this.dispatchEvent(event);
    }

    updateVisibleMediaHero(optionIndex, selectedValue) {
      const slides = Array.from(
        this.productSlider?.querySelectorAll('.product-images__slide') || []
      );
      slides.forEach((slide) => slide.classList.remove('is-visible-hero'));
      const optionKey = optionIndex ? `option${optionIndex}` : '';
      const featuredVariant = this.currentVariant || (optionKey && selectedValue
        ? this.getVariantData().find((variant) =>
          this.normalizeImageFilterValue(variant[optionKey]) === selectedValue
        )
        : null);
      const featuredMediaId = featuredVariant?.featured_media?.id ||
        featuredVariant?.featured_image?.id;
      const featuredSlide = featuredMediaId
        ? slides.find((slide) =>
          slide.style.display !== 'none' &&
          slide.dataset.mediaId?.endsWith(`-${featuredMediaId}`)
        )
        : null;
      const heroSlide = featuredSlide ||
        slides.find((slide) => slide.style.display !== 'none');
      heroSlide?.classList.add('is-visible-hero');
    }

    getOptionFieldsets() {
      return Array.from(this.querySelectorAll('fieldset')).filter((fieldset) => {
        return !fieldset.classList.contains('product-form__input--siblings') || this.isSiblingFieldsetVariantOption(fieldset);
      });
    }

    isMediaOptionFieldset(fieldset) {
      if (!fieldset) {
        return false;
      }
      if (fieldset.classList.contains('product-form__input--color')) {
        return true;
      }
      if (fieldset.classList.contains('product-form__input--siblings')) {
        return this.isSiblingFieldsetVariantOption(fieldset);
      }
      const handle = fieldset.dataset.handle || '';
      const optionIndex = Number((fieldset.dataset.index || '').replace('option', ''));
      return ['color', 'colour', 'couleur', 'farbe'].some((token) => handle.includes(token)) ||
        optionIndex === this.getMediaFilterOptionIndex();
    }

    isSiblingFieldsetVariantOption(fieldset) {
      if (!fieldset.classList.contains('product-form__input--siblings')) {
        return false;
      }
      const optionIndex = fieldset.dataset.index || '';
      const checkedInput = fieldset.querySelector('input:checked');
      if (!optionIndex || !checkedInput) {
        return false;
      }
      return this.getVariantData().some((variant) => variant[optionIndex] === checkedInput.value);
    }

    updateOptions() {
      this.fieldsets = this.getOptionFieldsets();
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          const checkedInput = fieldset.querySelector('input:checked');
          this.options.push(checkedInput ? checkedInput.value : '');
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
    }
    updateVariantText() {
      const fieldsets = this.fieldsets || this.getOptionFieldsets();
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i] || window.theme.variantStrings.selectOptions;
        }
      });
    }
    updateMasterId() {
      if (this.options.some((option) => !option)) {
        this.currentVariant = null;
        return;
      }
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].getOptionFieldsets ? this.other[0].getOptionFieldsets() : this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            const input = fieldsets_array[i].querySelector(`input[value="${option}"]`);
            fieldsets_array[i].querySelectorAll('input').forEach((radio) => {
              radio.checked = false;
            });
            if (input) {
              input.checked = true;
            }
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia({ scrollPage = false } = {}) {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;


      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      });
      if (scrollPage) {
        this.scrollMediaIntoView();
      }
    }

    scrollMediaIntoView() {
      if (window.matchMedia('(max-width: 767px)').matches) return;
      const target = this.productSlider || this.productWrapper;
      if (!target) return;
      window.requestAnimationFrame(() => {
        const headerOffset = 120;
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerOffset);
        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      });
    }

    updateURL() {
      if (this.dataset.updateUrl === 'false') return;
      if (this.hasColorwaySiblings) {
        window.history.replaceState({}, '', this.dataset.url);
        return;
      }
      const colorValue = this.getSelectedColorValue();
      const colorSlug = colorValue ? this.getColorSlug(colorValue) : '';
      const nextUrl = colorSlug ? `${this.dataset.url}?color=${encodeURIComponent(colorSlug)}` : this.dataset.url;
      window.history.replaceState({}, '', nextUrl);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      const colorValue = this.getSelectedColorValue();
      const colorSlug = colorValue ? this.getColorSlug(colorValue) : '';
      const shareUrl = colorSlug ? `${window.shopUrl}${this.dataset.url}?color=${encodeURIComponent(colorSlug)}` : `${window.shopUrl}${this.dataset.url}`;
      shareButton.updateUrl(shareUrl);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.disabled = false;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    clearVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = '';
        input.disabled = true;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      this.renderVariantPriceFromData(this.currentVariant);
      this.fetchAndRenderVariantSections(this.currentVariant)
        .then(() => {
          this.renderVariantPriceFromData(this.currentVariant);
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') throw error;
        });
    }

    getSelectedColorRepresentativeVariant() {
      const colorPosition = this.getColorOptionPosition();
      const selectedColor = colorPosition ? this.options[colorPosition - 1] : '';
      if (!colorPosition || !selectedColor) return null;

      const optionKey = `option${colorPosition}`;
      const matchingVariants = this.getVariantData().filter((variant) =>
        variant[optionKey] === selectedColor
      );
      return matchingVariants.find((variant) => variant.available) || matchingVariants[0] || null;
    }

    renderSelectedColorPrice() {
      const representativeVariant = this.getSelectedColorRepresentativeVariant();
      if (!representativeVariant) return;

      this.priceRequestController?.abort();
      this.priceRequestController = new AbortController();
      const signal = this.priceRequestController.signal;

      this.renderVariantPriceFromData(representativeVariant);
      this.fetchAndRenderVariantSections(representativeVariant, { signal })
        .then(() => {
          if (signal.aborted) return;
          this.renderVariantPriceFromData(representativeVariant);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') throw error;
        });
    }

    fetchAndRenderVariantSections(variant, { signal } = {}) {
      if (!variant) {
        return Promise.resolve();
      }

      return fetch(
        `${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`,
        signal ? { signal } : undefined
      )
        .then((response) => response.text())
        .then((responseText) => {
          if (signal?.aborted) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');
          });

          const paymentTerms = this.productWrapper?.querySelector('shopify-payment-terms');
          paymentTerms?.setAttribute('variant-id', variant.id);
        });
    }

    renderVariantPriceFromData(variant) {
      const destinationPrice = document.getElementById(`price-${this.dataset.section}`);
      if (!destinationPrice || !variant) {
        return;
      }

      const price = Number(variant.price);
      const compareAtPrice = Number(variant.compare_at_price || 0);
      if (!Number.isFinite(price)) {
        return;
      }

      const money = this.formatMoney(price);
      const compareMoney = compareAtPrice && compareAtPrice !== price
        ? this.formatMoney(compareAtPrice)
        : '';
      destinationPrice.innerHTML = compareMoney
        ? `<span class="price"><del><span class="amount">${compareMoney}</span></del> <ins><span class="amount">${money}</span></ins></span>`
        : `<span class="price"><ins><span class="amount">${money}</span></ins></span>`;
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
      }
      return `$${(cents / 100).toFixed(2)}`;
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('sold-out');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);
      const hasPartialSelection = this.options.some((option) => !option);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = this.getUnavailableButtonText(hasPartialSelection);
        submitButton.classList.add('sold-out');
      });
      if (hasPartialSelection) return;
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      const variant_data = this.getVariantData();
      const disableUnavailable = this.isDisabledFeature === 'true';


      if (variant_data) {
        this.fieldsets.forEach((fieldset, i) => {
          const optionIndex = fieldset.dataset.index || `option${i + 1}`;

          const select = fieldset.querySelector('select');
          if (select) {
            const selectedValue = select.value;
            select.originalOptions = select.originalOptions || Array.from(select.options).map((option) => option.cloneNode(true));
            select.replaceChildren(...select.originalOptions.map((option) => option.cloneNode(true)));
            select.value = selectedValue;

            Array.from(select.options).forEach((option) => {
              if (!option.value) {
                option.hidden = false;
                return;
              }
              const unavailable = !this.isOptionAvailableWithCurrentSelection(variant_data, optionIndex, option.value);
              option.disabled = disableUnavailable && unavailable;
              option.hidden = false;
              this.setSoldOutOptionLabel(option, unavailable && disableUnavailable);
            });
          } else if (fieldset.querySelectorAll('input').length) {
            if (fieldset.classList.contains('product-form__input--color')) {
              fieldset.querySelectorAll('input').forEach((input) => {
                const unavailable = !this.isOptionAvailableAcrossVariants(variant_data, optionIndex, input.value);
                input.classList.remove('is-disabled');
                input.classList.toggle('is-unavailable', unavailable);
                input.disabled = false;
                input.removeAttribute('aria-disabled');
                this.setSoldOutRadioLabel(fieldset, input, false);
              });
              return;
            }

            if (fieldset.classList.contains('product-form__input--siblings')) {
              fieldset.querySelectorAll('input').forEach((input) => {
                input.classList.remove('is-disabled');
                input.classList.remove('is-unavailable');
                input.disabled = false;
                input.removeAttribute('aria-disabled');
              });
              return;
            }

            fieldset.querySelectorAll('input').forEach((input) => {
              const unavailable = !this.isOptionAvailableWithCurrentSelection(variant_data, optionIndex, input.value);
              input.classList.toggle('is-disabled', disableUnavailable && unavailable);
              input.classList.toggle('is-unavailable', unavailable);
              input.disabled = disableUnavailable && unavailable;
              if (disableUnavailable && unavailable) {
                input.setAttribute('aria-disabled', 'true');
              } else {
                input.removeAttribute('aria-disabled');
              }
              this.setSoldOutRadioLabel(fieldset, input, false);
            });
          }
        });

      }
      return true;
    }

    setSoldOutOptionLabel(option, unavailable) {
      const baseLabel = option.dataset.baseLabel || option.textContent.trim();
      option.dataset.baseLabel = baseLabel;
      option.textContent = unavailable
        ? `${baseLabel} — ${window.theme.variantStrings.soldOut}`
        : baseLabel;
    }

    setSoldOutRadioLabel(fieldset, input, unavailable) {
      const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      const labelText = label?.querySelector('span');
      if (!labelText) return;

      const baseLabel = labelText.dataset.baseLabel || labelText.textContent.trim();
      labelText.dataset.baseLabel = baseLabel;
      labelText.textContent = unavailable
        ? `${baseLabel} — ${window.theme.variantStrings.soldOut}`
        : baseLabel;
      label?.classList.toggle('is-unavailable', unavailable);
    }

    selectFirstAvailableVariantForChangedOption(fieldset) {
      if (!this.isMediaOptionFieldset(fieldset)) {
        return false;
      }

      const optionIndex = fieldset.dataset.index || '';
      const selectedValue = this.options[Number(optionIndex.replace('option', '')) - 1];
      if (!optionIndex || !selectedValue) {
        return false;
      }

      const firstAvailableVariant = this.getVariantData().find((variant) => {
        return variant.available && variant[optionIndex] === selectedValue;
      });
      if (!firstAvailableVariant) {
        return false;
      }

      this.selectVariantOptions(firstAvailableVariant);
      return true;
    }

    selectFirstAvailableVariantForInitialMediaOption() {
      const searchParams = new URLSearchParams(window.location.search);
      if (!searchParams.get('color') || searchParams.get('variant')) {
        return false;
      }

      const mediaOptionIndex = this.getColorOptionPosition();
      if (!mediaOptionIndex) {
        return false;
      }

      const fieldset = this.fieldsets.find((item) => {
        return (item.dataset.index || '') === `option${mediaOptionIndex}`;
      });
      if (!fieldset || !this.isMediaOptionFieldset(fieldset)) {
        return false;
      }

      return this.selectFirstAvailableVariantForChangedOption(fieldset);
    }

    getUnavailableButtonText(hasPartialSelection) {
      if (this.isSelectedMediaOptionSoldOut()) {
        return window.theme.variantStrings.soldOut;
      }

      return hasPartialSelection
        ? window.theme.variantStrings.selectOptions
        : window.theme.variantStrings.unavailable;
    }

    isSelectedMediaOptionSoldOut() {
      const mediaOptionIndex = this.getColorOptionPosition();
      if (!mediaOptionIndex || !this.fieldsets || this.fieldsets.length < 2) {
        return false;
      }

      const selectedValue = this.options[mediaOptionIndex - 1];
      if (!selectedValue) {
        return false;
      }

      const optionIndex = `option${mediaOptionIndex}`;
      const matchingVariants = this.getVariantData().filter((variant) => {
        return variant[optionIndex] === selectedValue;
      });

      return matchingVariants.length > 0 && !matchingVariants.some((variant) => variant.available);
    }

    selectVariantOptions(variant) {
      this.fieldsets.forEach((fieldset, index) => {
        const optionIndex = fieldset.dataset.index || `option${index + 1}`;
        const value = variant[optionIndex];
        if (!value) {
          return;
        }

        const select = fieldset.querySelector('select');
        if (select && Array.from(select.options).some((option) => option.value === value)) {
          select.value = value;
          return;
        }

        const input = Array.from(fieldset.querySelectorAll('input')).find((radio) => {
          return radio.value === value;
        });
        if (input) {
          fieldset.querySelectorAll('input').forEach((radio) => {
            radio.checked = false;
          });
          input.checked = true;
        }
      });

      this.updateOptions();
      this.updateMasterId();
      this.updateVariantText();
    }

    isOptionAvailableWithCurrentSelection(variant_data, optionIndex, optionValue) {
      return variant_data.some((variant) => {
        if (!variant.available || variant[optionIndex] !== optionValue) {
          return false;
        }

        return this.options.every((selectedOption, selectedIndex) => {
          const selectedOptionIndex = `option${selectedIndex + 1}`;
          return (
            selectedOptionIndex === optionIndex ||
            !selectedOption ||
            variant[selectedOptionIndex] === selectedOption
          );
        });
      });
    }

    isOptionAvailableAcrossVariants(variant_data, optionIndex, optionValue) {
      return variant_data.some((variant) => {
        return variant.available && variant[optionIndex] === optionValue;
      });
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    getColorSlug(value) {
      return this.normalizeImageFilterValue(value)
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-$/, '')
        .replace(/^-/, '');
    }

    normalizeImageFilterValue(value) {
      // Keep slash-delimited color names comparable between option values and media alt text.
      return (value || '')
        .toString()
        .toLowerCase()
        .replace(/["']/g, '')
        .replace(/\s*\/\s*/g, '/')
        .replace(/\s+/g, ' ')
        .trim();
    }

    getMediaFilterTokens(value) {
      const normalized = this.normalizeImageFilterValue(value);
      const readableAlt = normalized.split('#')[0].trim();
      if (!readableAlt) {
        return [];
      }

      return readableAlt
        .split('|')
        .map((token) => this.normalizeImageFilterValue(token))
        .filter(Boolean);
    }

    getMediaSourceKey(value) {
      if (!value) {
        return '';
      }

      const filename = value
        .toString()
        .split('?')[0]
        .split('/')
        .pop()
        .toLowerCase()
        .replace(/\.[a-z0-9]+$/, '')
        .split('_')[0]
        .replace(/-\d+$/, '');
      return filename.trim();
    }

    getVariantFeaturedMediaSource(variant) {
      return variant?.featured_media?.preview_image?.src ||
        variant?.featured_media?.src ||
        variant?.featured_image?.src ||
        '';
    }

    getMediaFilterValuesFromSource(mediaSrc, optionIndex) {
      const mediaSourceKey = this.getMediaSourceKey(mediaSrc);
      if (!mediaSourceKey || !optionIndex) {
        return [];
      }

      const optionKey = `option${optionIndex}`;
      return Array.from(new Set(
        this.getVariantData()
          .filter((variant) => this.getMediaSourceKey(
            this.getVariantFeaturedMediaSource(variant)
          ) === mediaSourceKey)
          .map((variant) => this.normalizeImageFilterValue(variant[optionKey]))
          .filter(Boolean)
      ));
    }

    getAllVariantOptionValueSet() {
      return new Set(
        this.getVariantData()
          .flatMap((variant) => [variant.option1, variant.option2, variant.option3])
          .map((value) => this.normalizeImageFilterValue(value))
          .filter(Boolean)
      );
    }

    getVariantOptionValueSet(optionIndex) {
      const key = `option${optionIndex}`;
      return new Set(
        this.getVariantData()
          .map((variant) => this.normalizeImageFilterValue(variant[key]))
          .filter(Boolean)
      );
    }

    getMediaFilterOptionIndex() {
      const sliderImageAlts = new Set(
        Array.from(this.productSlider.querySelectorAll('.product-images__slide--image[data-alt]'))
          .flatMap((slide) => this.getMediaFilterTokens(slide.dataset.alt))
          .filter(Boolean)
      );

      if (!sliderImageAlts.size) {
        return null;
      }

      let bestIndex = null;
      let bestMatchCount = 0;

      [1, 2, 3].forEach((optionIndex) => {
        const optionValues = this.getVariantOptionValueSet(optionIndex);
        if (!optionValues.size) {
          return;
        }

        let matchCount = 0;
        optionValues.forEach((value) => {
          if (sliderImageAlts.has(value)) {
            matchCount += 1;
          }
        });

        if (matchCount > bestMatchCount) {
          bestMatchCount = matchCount;
          bestIndex = optionIndex;
        }
      });

      return bestMatchCount > 0 ? bestIndex : null;
    }

    getColorOptionPosition() {
      const colorFieldset = this.fieldsets.find((fieldset) => {
        const handle = fieldset.dataset.handle || '';
        return ['color', 'colour', 'couleur', 'farbe'].some((token) => handle.includes(token));
      });

      if (colorFieldset) {
        return Number((colorFieldset.dataset.index || '').replace('option', ''));
      }

      return this.productSlider ? this.getMediaFilterOptionIndex() : null;
    }

    getSelectedColorValue() {
      const colorPosition = this.getColorOptionPosition();
      if (!colorPosition) return '';
      return this.options[colorPosition - 1] || '';
    }

    applyColorFromURL() {
      const requestedColor = new URLSearchParams(window.location.search).get('color');
      if (!requestedColor) return;

      if (this.hasColorwaySiblings) {
        const requestedSlug = requestedColor.toString().toLowerCase().trim();
        const matchingSiblingLink = Array.from(this.querySelectorAll('.product-form__input--siblings label[data-color] a[href]')).find((link) => {
          const label = link.closest('label');
          return label && this.getColorSlug(label.dataset.color) === requestedSlug;
        });

        if (matchingSiblingLink) {
          window.location.replace(matchingSiblingLink.href);
          return true;
        }

        const currentLabel = this.querySelector('.product-form__input--siblings label.active[data-color]');
        if (currentLabel && this.getColorSlug(currentLabel.dataset.color) === requestedSlug) {
          window.history.replaceState({}, '', this.dataset.url);
          return false;
        }

        window.history.replaceState({}, '', this.dataset.url);
        return false;
      }

      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      const colorPosition = this.getColorOptionPosition();
      if (!colorPosition) return;

      const fieldset = this.fieldsets[colorPosition - 1];
      if (!fieldset) return;

      const colorInput = Array.from(fieldset.querySelectorAll('input')).find((input) => {
        return this.getColorSlug(input.value) === requestedColor;
      });
      if (colorInput) {
        colorInput.checked = true;
        return;
      }

      const colorSelect = fieldset.querySelector('select');
      if (!colorSelect) return;
      const colorOption = Array.from(colorSelect.options).find((option) => {
        return this.getColorSlug(option.value) === requestedColor;
      });
      if (colorOption) {
        colorSelect.value = colorOption.value;
      }
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex || !this.currentVariant) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = this.getOptionFieldsets();
      this.options = fieldsets.map((fieldset) => {
        const checkedInput = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        return checkedInput ? checkedInput.value : '';
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
      this.addEventListener('variantImagesUpdated', (event) => {
        this.handleVariantImagesUpdated(event.detail.currentVariant);
      });
    }
    handleVariantImagesUpdated(currentVariant) {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      if (!this.pagination) {
        return;
      }
      this.setupPagination();
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.dotsContainer = this.pagination.querySelector('.slider-dots-container');
      this.sliderItemsToShow = this.getVisibleSliderItems();
      if (this.sliderItemsToShow.length < 2) {
        if (this.dotsContainer) {
          this.dotsContainer.innerHTML = '';
        }
        this.dots = [];
        if (this.pagination) {
          this.pagination.style.display = 'none';
        }
        return;
      } else {
        if (this.pagination) {
          this.pagination.style.display = '';
        }
      }

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      // Remove or hide the original counter elements
      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      if (this.currentPageElement) this.currentPageElement.style.display = 'none';
      if (this.pageTotalElement) this.pageTotalElement.style.display = 'none';

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));


      // Initialize dots
      this.setupDotPagination();
      this.updatePagination();
    }

    setupDotPagination() {
      this.dotsContainer = this.pagination.querySelector('.slider-dots-container');
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      this.sliderItemsToShow = this.getVisibleSliderItems();

      this.dots = [];

      this.sliderItemsToShow.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('slider-dot');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.setAttribute('data-slide-index', index);

        dot.addEventListener('click', (event) => {
          event.preventDefault();
          this.goToSlide(index);
        });

        const span = document.createElement('span');
        dot.appendChild(span);

        this.dotsContainer.appendChild(dot);
        this.dots.push(dot);
      });
    }

    getVisibleSliderItems() {
      return Array.from(this.sliderItems).filter(
        element => element.clientWidth > 0 && getComputedStyle(element).display !== 'none'
      );
    }

    // Add this function to navigate to specific slide
    goToSlide(slideIndex) {
      this.slideScrollPosition = slideIndex * this.sliderItemOffset;
      this.scrollTo({
        left: this.slideScrollPosition,
        behavior: 'smooth' // Optional: adds smooth scrolling
      });
    }
    onPaginationResize() {
      this.sliderItemsToShow = this.getVisibleSliderItems();
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      // Update dots instead of counter text
      if (this.dots) {
        this.dots.forEach((dot, index) => {
          const isActive = (index + 1) === this.currentPage;
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      //this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form = this.querySelector(`#product-form-${this.dataset.section}`) || this.querySelector('form');
      if (!this.form) {
        return;
      }
      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput && variantInput.value) {
        variantInput.disabled = false;
      }
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const variantInput = this.form.querySelector('[name=id]');
      if (!variantInput || !variantInput.value) {
        this.handleErrorMessage(window.theme.variantStrings.selectOptions);
        return;
      }
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
